module.exports = __webpack_public_path__ + "static/banner-537478fce295b7288dfbdce53f0dcb37.jpeg";